export const environment = {
  production: true,
  name: 'test',
  apiUrl: '',
  enableDevTools: false,
  logLevel: 'warn'
};
